import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { X, Sparkles } from "lucide-react";
import { api } from "@/lib/api";

// Phase 18-A2 item 3: site-wide campaign banner. Shows while a campaign is
// active AND banner_enabled — entirely config-driven (no rebuild), dismissible
// per user per campaign (localStorage key includes the campaign id).
export function CampaignBanner() {
  const [c, setC] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    api.activeCampaign()
      .then((r) => {
        const camp = r.campaign;
        if (camp && camp.banner_enabled) {
          setC(camp);
          try {
            setDismissed(localStorage.getItem(`campaign_banner_dismissed_${camp.id}`) === "1");
          } catch { /* ignore */ }
        }
      })
      .catch(() => {});
  }, []);

  if (!c || dismissed || pathname.startsWith(`/campaigns/`)) return null;

  const dismiss = () => {
    setDismissed(true);
    try { localStorage.setItem(`campaign_banner_dismissed_${c.id}`, "1"); } catch { /* ignore */ }
  };

  return (
    <div data-testid="campaign-banner" className="bg-forest text-white">
      <div className="max-w-6xl mx-auto px-6 py-2.5 flex items-center gap-3 text-sm">
        <Sparkles className="w-4 h-4 text-terracotta shrink-0" />
        <span className="truncate">
          <span className="font-semibold">{c.name}</span>
          {c.blurb ? <span className="hidden sm:inline text-white/80"> — {c.blurb.slice(0, 90)}</span> : null}
        </span>
        <Link
          to={`/campaigns/${c.slug}`}
          data-testid="campaign-banner-link"
          className="ml-auto shrink-0 underline underline-offset-4 font-medium hover:text-terracotta transition-colors"
        >
          Join in
        </Link>
        <button data-testid="campaign-banner-dismiss" onClick={dismiss} aria-label="Dismiss" className="shrink-0 hover:text-terracotta transition-colors">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
